var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"edss-score"},[_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm.mapping[_vm.$store.state.year]))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("EDSS"),_c('br'),_vm._v("Score")])
}]

export { render, staticRenderFns }